import { Component, Input, OnInit } from '@angular/core';

export function getStatusClass(status: string): string {
  if (!status) {
    return 'unknown';
  }
  const s = status.toUpperCase();

  if (s.includes('SUBMISSION_FAILED')) {
    return 'warning';
  }
  if (s.includes('REJECTED') || s.includes('FAILED') || s.includes('ERROR') || s.includes('CANCELED') || s.includes('CANCELLED')) {
    return 'failed';
  }
  if (s.includes('SUBMITTED_TO_BANK') || s.includes('COMPLETED') || s.includes('PAID') || s.includes('SUCCESS') || s.includes('ACCEPTED')) {
    return 'success';
  }

  return 'pending';
}

// Shared display formatting for the outgoing-payment status/state enums:
// `IN_PROGRESS` -> "In Progress". Exported so surfaces beyond this label
// component (e.g. the list-page status filter) speak the same vocabulary.
export function formatStatus(status: string): string {
  if (!status) {
    return 'Unknown';
  }
  return status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

@Component({
  selector: 'app-outgoing-payment-status-label',
  templateUrl: './outgoing-payment-status-label.component.html',
  styleUrls: ['./outgoing-payment-status-label.component.scss']
})
export class OutgoingPaymentStatusLabelComponent implements OnInit {
  @Input() status: string;
  @Input() state: string;
  @Input() statusReason: string;

  formattedStatus: string;
  formattedState: string;
  statusClass: string;

  constructor() { }

  ngOnInit(): void {
    this.formattedStatus = formatStatus(this.status);
    this.formattedState = formatStatus(this.state);
    this.statusClass = getStatusClass(this.status);
  }
}
